var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "icon icon-tabler icons-tabler-outline icon-tabler-file-type-html",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h32v32H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.667 4v5.333a1.333 1.333 0 0 0 1.333 1.334h5.333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.667 16v-9.333a2.667 2.667 0 0 1 2.666-2.667h9.334L25.333 9.333V16"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.667 28v-8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.667 20v8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.667 24h4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 20v8h2.667"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.333 28v-8l2.667 4l2.667-4v8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20h4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20v8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.87531f482c8f238bb91d381ac218030c.svg";
export { ForwardRef as ReactComponent };